import React from "react";
import classes from "./Footer.module.css";


function Footer (props){

    return (
        <div>
                <div className={classes.footer}>
                    <p className={classes.footerText}>@Copyright......</p>
                </div>
        </div>
        
    );
}

export default Footer